import React from "react";

export class ResponsibleDisclosureNL extends React.Component {
    render() {
        return (
            <>
                <p>
                    Laatste update: <b>29/03/2024</b>
                    <br />
                    <br />
                </p>

                <p>Bij DH Healthcare GmbH vinden wij de veiligheid van onze systemen erg belangrĳk.</p>

                <p>Ondanks onze zorg voor de beveiliging van onze systemen kan het voorkomen dat er toch een zwakke plek is.</p>

                <p>
                    Als u een zwakke plek in één van onze systemen heeft gevonden horen wij dit graag zodat we zo snel mogelĳk maatregelen kunnen treffen. Wij willen graag met u
                    samenwerken om onze klanten en onze systemen beter te kunnen beschermen.
                </p>

                <p>
                    We hebben daarom gekozen voor een beleid van gecoördineerde openbaarmaking van kwetsbaarheden (ook bekend als het ‘Responsible Disclosure Beleid’), zodat u ons
                    kunt informeren wanneer u een kwetsbaarheid ontdekt.
                </p>

                <p>Dit beleid inzake verantwoorde openbaarmaking is van toepassing op de volgende systemen, onderhouden door DH Healthcare GmbH:</p>
                <ul>
                    <li>
                        <a href="https://www.dobcomed.com" target="_blank" rel="noreferrer">
                            https://www.dobcomed.com
                        </a>
                    </li>
                    <li>
                        <a href="https://secure.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://secure.pacsonweb.com
                        </a>
                    </li>
                    <li>
                        <a href="https://france.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://france.pacsonweb.com
                        </a>
                    </li>
                    <li>
                        <a href="https://norway.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://norway.pacsonweb.com
                        </a>
                    </li>
                    <li>
                        <a href="https://swiss.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://swiss.pacsonweb.com
                        </a>
                    </li>
                    <li>
                        <a href="https://germany.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://germany.pacsonweb.com
                        </a>
                    </li>
                    <li>
                        <a href="https://latem.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://latem.pacsonweb.com
                        </a>
                    </li>
                    <li>
                        <a href="https://brazil.imaging.dedalus.com" target="_blank" rel="noreferrer">
                            https://brazil.imaging.dedalus.com
                        </a>
                    </li>
                    <li>
                        <a href="https://austria.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://austria.pacsonweb.com
                        </a>
                    </li>
                    <li>
                        <a href="https://swisscom.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://swisscom.pacsonweb.com
                        </a>
                    </li>
                    <li>
                        <a href="https://labs.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://labs.pacsonweb.com
                        </a>
                    </li>

                    <li>
                        <a href="https://secure.risonweb.com" target="_blank" rel="noreferrer">
                            https://secure.risonweb.com
                        </a>
                    </li>
                </ul>

                <p>
                    In geval van twijfel, kunt u contact opnemen met ons op om de zaken te verduidelijken via <a href="mailto:infosec@dobcomed.com">infosec@dobcomed.com</a>
                </p>

                <h2>Wat wij van u vragen</h2>

                <p>Als je een kwetsbaarheid ontdekt in een van onze systemen, verzoeken wij u om:</p>

                <ul>
                    <li>
                        de kwetsbaarheid zo snel mogelijk na ontdekkingte melden. Mail uw bevindingen naar <a href="mailto:infosec@dobcomed.com">infosec@dobcomed.com</a>.
                    </li>
                    <li>
                        Geef voldoende informatie om de kwetsbaarheid te reproduceren zodat we het probleem zo snel mogelijk kunnen oplossen. Meestal is de URL van het getroffen
                        systeem en een beschrijving van de kwetsbaarheid voldoende, maar voor complexere kwetsbaarheden kan er meer nodig zijn.
                    </li>
                    <li>
                        Laat uw contactgegevens achter, zodat DH Healthcare GmbH contact met u kan opnemen om samen te werken aan een veilig resultaat. Laat in ieder geval uw naam,
                        e-mailadres en / of telefoonnummer achter. Melden onder een pseudoniem is mogelijk, maar zorg ervoor dat we contact met je kunnen opnemen als we nog vragen
                        hebben.
                    </li>
                    <li>Bevestig dat u heeft gehandeld en zal blijven handelen in overeenstemming met dit Beleid inzake verantwoordelijke openbaarmaking.</li>
                </ul>

                <h2>Regels die u moet volgen</h2>

                <ul>
                    <li>Maak de kwetsbaarheid pas bekend als we deze hebben kunnen verhelpen. Zie hieronder voor mogelijke publicatie.</li>
                    <li>
                        Maak geen misbruik van de kwetsbaarheid door onnodig gegevens te kopiëren, verwijderen, aanpassen of bekijken. Of bijvoorbeeld door meer data te downloaden
                        dan nodig is om de kwetsbaarheid aan te tonen.
                    </li>
                    <li>
                        Pas de volgende acties niet toe:
                        <ul>
                            <li>Malware plaatsen (virus, worm, Trojaans paard, enz.).</li>
                            <li>Kopiëren, wijzigen of verwijderen van gegevens in een systeem.</li>
                            <li>Wijzigingen aanbrengen in het systeem.</li>
                            <li>Herhaaldelijk toegang krijgen tot het systeem of toegang delen met anderen.</li>
                            <li>Met behulp van geautomatiseerde scantools.</li>
                            <li>Gebruik van de zogenaamde "brute kracht" van toegang tot systemen.</li>
                            <li>Gebruik maken van (D)DOS aanvallen, , aanvallen op fysieke beveiliging of social engineering (phishing, vishing, spam, ...).</li>
                        </ul>
                    </li>
                    <li>Wis onmiddellijk alle gegevens die zijn verkregen door kwetsbaarheid zodra deze zijn gemeld aan DH Healthcare GmbH.</li>
                    <li>
                        Voer geen handelingen uit die een impact kunnen hebben op de goede werking van het systeem, zowel wat betreft beschikbaarheid en prestatie, maar ook wat
                        betreft vertrouwelijkheid en integriteit van de gegevens.
                    </li>
                </ul>

                <p>
                    Handelingen onder dit Responsible Disclosure-beleid moeten worden beperkt tot het uitvoeren van tests om potentiële kwetsbaarheden te identificeren en het delen
                    van deze informatie met DH Healthcare GmbH.
                </p>
                <p>
                    Indien u na het verwijderen van de kwetsbaarheid informatie over de kwetsbaarheid wilt publiceren, vragen wij u dit minimaal een maand voor publicatie aan ons
                    door te geven en ons de gelegenheid te geven hierop te reageren. Identificatie in een publicatie is alleen mogelijk na onze uitdrukkelijke toestemming.
                </p>

                <h2>Wat we beloven</h2>

                <p>Als u heeft voldaan aan de bovenstaande voorwaarden van het Responsible Disclosure-beleid en geen andere inbreuken heeft gepleegd,</p>
                <ul>
                    <li>we zullen geen juridische stappen tegen u ondernemen.</li>
                    <li>
                        wij zullen binnen korte tijd, indien mogelijk binnen 10 werkdagen, op uw melding reageren met onze beoordeling van de melding en een eventuele verwachte
                        datum voor een oplossing.
                    </li>
                    <li>
                        wij behandelen uw melding vertrouwelijk en delen uw persoonsgegevens niet met derden zonder uw toestemming, tenzij dit noodzakelijk is om te voldoen aan een
                        wettelijke verplichting.
                    </li>
                    <li>we houden u op de hoogte van de voortgang van het oplossen van het probleem.</li>
                    <li>
                        we willen u bedanken voor het melden van een beveiligingsprobleem dat nog niet bij ons bekend is door de mogelijkheid te bieden om opgenomen te worden in
                        onze <a href="/POW3/HallOfFame">"Hall Of Fame"</a>.
                    </li>
                    <li>we streven ernaar om alle problemen binnen korte tijd op te lossen.</li>
                </ul>

                <p>We kunnen er echter voor kiezen om rapporten van lage kwaliteit te negeren.</p>
                <p>
                    Als u vragen heeft, raden we u aan deze te richten aan <a href="mailto:infosec@dobcomed.com">infosec@dobcomed.com</a>
                </p>
                <p>Neem bij twijfel over de toepasselijkheid van dit beleid eerst contact met ons op via dit e-mailadres om expliciete toestemming te vragen.</p>
                <p>We behouden ons het recht voor om de inhoud van dit beleid op elk moment te wijzigen of om het beleid te beëindigen.</p>
                <p>Deze tekst is een afgeleid werk van "Responsible Disclosure" door Floor Terra, gebruikt onder een Creative Commons Attribution-licentie 3.0.</p>
            </>
        );
    }
}
